
const COOKIE_NAME = "is-adult";
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export default {
  computed: {
    isAdult() {
      return this.$store.state.global.isAdult;
    },
  },

  watch: {
    isAdult: {
      handler(value) {
        this.togglePageScrollLock(!value);
      },
      immediate: true,
    },
  },

  beforeDestroy() {
    this.togglePageScrollLock(false);
  },

  methods: {
    togglePageScrollLock(isLocked) {
      if (!process.client) return;

      const overflowValue = isLocked ? "hidden" : "";
      document.documentElement.style.overflowY = overflowValue;
      document.body.style.overflowY = overflowValue;
    },

    leaveWebsite() {
      window.location.href = "https://www.google.com";
    },

    iAmOver18() {
      this.$cookies.set(COOKIE_NAME, true, {
        path: "/",
        maxAge: COOKIE_MAX_AGE,
        sameSite: "lax",
      });
      this.$store.commit("global/setIsAdult", true);
    },
  },
};
